import { useTranslation } from 'react-i18next';
import type { CapiProductPage } from 'types/capi/pdp';

import Content from '~/components/Content';
import Paragraph from '~/components/Content/Paragraph';
import PopoutContainer from '~/components/PopoutContainer';
import Tracked from '~/components/Tracked';
import useEnv from '~/hooks/useEnv';
import usePageData from '~/hooks/usePageData';

type Props = {
  showEditorialPolicy?: boolean;
};

const ProductDescription = ({ showEditorialPolicy = true }: Props) => {
  const { content } = usePageData<CapiProductPage>();
  const { SITE_BASE_URL } = useEnv();
  const { t } = useTranslation('pdp');

  return (
    <div
      data-cy="product-description"
      className="flex flex-col items-start gap-6 md:gap-10"
    >
      <h2 className="text-title-sm">{t('description')}</h2>
      <div className="flex flex-col gap-10">
        <Content content={content} />

        {showEditorialPolicy && (
          <PopoutContainer>
            <Paragraph>
              {t('commissionDisclaimer')}{' '}
              <Tracked.ExternalLink
                className="inline font-semibold underline"
                href={`${SITE_BASE_URL}/about#editorial-policy`}
                pagePosition="Body"
                variant="none"
                name="EDITORIAL_POLICY"
              >
                {t('editorialPolicyLink')}
              </Tracked.ExternalLink>
            </Paragraph>
          </PopoutContainer>
        )}
      </div>
    </div>
  );
};

export default ProductDescription;
